import { useCallback, useEffect } from 'react'
import { register, subscribe, subscribeAsUser } from '../../../Library/worker';

const useInitServiceWorker = (setNotifications, isUser, webPushAllowed) => {
  const onNewNotification = useCallback((notification) => {
    setNotifications((old) => {
      if (!old) return null;
      return { unreadCount: old.unreadCount + 1, notifs: [ notification.data.data, ...old.notifs ] };
    });
  }, []);

  useEffect(() => {
    if (isUser && !webPushAllowed) return;

    const initServiceWorker = async () => {
      try {
        await register();
        await (isUser ? subscribeAsUser() : subscribe());

        /* Registering Service Worker Actions */
        const channel = new BroadcastChannel("ajjas-ev-messages");
        channel.addEventListener("message", (event) => {
          onNewNotification(event);
        });

      } catch(error) {
        console.warn("Error in initServiceWorker:", error);
      }
    };
    initServiceWorker();
  }, [isUser, webPushAllowed]);
}

export default useInitServiceWorker